import {VehicleDataProvider} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";
import {KEYLOOP_PIPELINE_SEARCH_PROVIDER} from "../../../../../location/types/pipelineSearch";

export const allVehicleDataProviderOptions: SelectOption<VehicleDataProvider>[] = [
    {
        label: "No Provider",
        value: VehicleDataProvider.NoProvider
    },
    {
        label: "Autotrader",
        value: VehicleDataProvider.Autotrader
    },
    {
        label: "TMC Autotrader",
        value: VehicleDataProvider.TmcAutotrader
    },
    {
        label: "File on SFTP",
        value: VehicleDataProvider.FileOnSftp
    },
    {
        label: "Pipeline Stock File",
        value: VehicleDataProvider.PipelineStockFile
    },
    {
        label: "Spidersnet File",
        value: VehicleDataProvider.SpidersnetFile
    },
    {
        label: "Autotrader And File on SFTP",
        value: VehicleDataProvider.AutotraderAndFileOnSftp
    },
    {
        label: "Keyloop Pipeline Search",
        value: KEYLOOP_PIPELINE_SEARCH_PROVIDER
    }
]

export const getVehicleDataProviderName = (vehicleDataProvider: VehicleDataProvider) => {
    const option = allVehicleDataProviderOptions.filter(o => o.value === vehicleDataProvider)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle vehicleDataProvider: ${vehicleDataProvider} correctly`)
}
